// Autogenerated file
export const routerCountryTypesEnum = {
    Russia: "Russia",
};
export const routerCountryTypes = [
    { label: "Россия", value: "Russia" },
];
